import { render, staticRenderFns } from "./NovoCadastro.vue?vue&type=template&id=cc8edf28&"
import script from "./NovoCadastro.vue?vue&type=script&lang=js&"
export * from "./NovoCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports